export enum DcLoaders {
	LoaderInfinite = './src/img/loaders/infinite-spinner.svg',
}
